<template id="bs-modal-asset">
<div class="modal fade" id="assetCreateModal" tabindex="-1" role="dialog" aria-labelledby="assetCreateModal">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">

			<div class="text-gray-500 font-weight-bold text-uppercase text-base bg-gray-100 px-3 py-25 mb-3 rounded-top border-bottom">
				<span>Create Media Asset</span>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
		        	<span aria-hidden="true">&times;</span>
		        </button>
			</div>

			<div class="modal-body py-0 px-3">

				<form
					@submit.prevent="submitForm"
					@keydown="form.onKeydown($event)"
					@change="form.onKeydown($event)">	

					<div class="row">

						<div class="col-12">
							<alert-errors :form="form">There were some problems with your input.</alert-errors>
							<alert-success :form="form">Your asset was saved!</alert-success>
						</div>
						

						<div class="col-md-4 col-sm-6 mb-3">
							<label class="mb-0">File</label>
							<file-field
								ref="file"	
								@file_changed="changedFile($event)"
							/>
						</div>

						<div class="col-md-8 col-sm-6">
							<div class="form-group">
								<label class="mb-0">Asset Name <span class="text-gray-500"> - Optional</span></label>
								<input type="text" class="form-control" v-model="form.name">
								<div class="form-text text-sm text-gray-500">Will use file name if empty</div>
							</div>

						    <div class="form-group">
						    	<label class="mb-0">Details <span class="text-gray-500"> - Optional</span></label>
		                        <v-select
		                        	placeholder="Asset Type"
		                        	multiple
		                            label="label"
		                            :options="asset_types"
		                            :reduce="label => label.id"
		                            v-model="form.asset_types"
		                        />
						    </div>

						    <div class="form-group">
		                        <v-select
		                        	placeholder="Service Lines"
		                            multiple
		                            label="label"
		                            :options="options.service_lines"
		                            :reduce="label => label.id"
		                            v-model="form.service_lines"
		                        />
						    </div>

						    <div class="form-group">
		                        <v-select
		                        	placeholder="Specialties"
		                            multiple
		                            label="label"
		                            :options="options.specialties"
		                            :reduce="label => label.id"
		                            v-model="form.specialties"
		                        />
						    </div>
						</div>	


						<div class="col-12 border-top p-3 text-right">
							<button :disabled="form.busy || !form.file" type="submit" class="btn btn-primary">Add Asset</button>
						</div>


					</div>
				</form>
			</div>
		</div>
	</div>
</div>
</template>


<script>

	import { mapState } from 'vuex';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata'

	export default {
		props: ['asset_types'],

		components: {
			HasError,
			AlertError,
			AlertErrors,
			AlertSuccess,
			Form,
		},


		data() {
			return {
				in_progress: false,
				form: {},
			}
		},

		created() {
			this.createForm();
		},

		mounted() {

		},

		methods: {
			changedFile($event) {
				this.form.file = this.$refs.file.file;
			},

			createForm() {
				this.form = new Form({
					name: null,
					asset_types: null,
					service_lines: null,
					specialties: null,
					file: null,
				});
			},

			submitForm() {
				this.in_progress = true;
				this.form.submit('post', '/api/assets', {
					transformRequest: [function (data, headers) {
						return objectToFormData(data)
					}],
				}).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Asset created',
					});						
					
					this.in_progress = false;
					this.$emit('asset_added', data);
					jQuery('#assetCreateModal').modal('hide');
					this.createForm();
				});
			},
		},

		computed: {
			...mapState(['options', 'user']),
		}

	}

</script>

<style scoped>
	h3.title { color:#a4aaae; font-weight:bold; font-size:120%; margin-bottom:1rem; }
	.button-wrap { border-top:1px solid #e4e7ea; margin:0 -1rem; }
</style>